import { render } from "./notdate.vue?vue&type=template&id=842621f4"
import script from "./notdate.vue?vue&type=script&lang=js"
export * from "./notdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__